import { createAction } from '@mews/framework';
import { createSafeToUtcDateStringConverter } from '@mews-commander/utils';
import { prefix } from '../module';
import { fetchRateManagementData } from './api';

export const RATE_MANAGEMENT_FILTER_CHANGED = prefix('RATE_MANAGEMENT_FILTER_CHANGED');

export const changeDateFilter = (dates: $TSFixMe, scope: $TSFixMe) =>
    createAction(RATE_MANAGEMENT_FILTER_CHANGED, dates, { scope });

export const submitRateManagementFilterValues =
    ({ productId, rateId, serviceId, startDate, endDate }: $TSFixMe) =>
    (dispatch: $TSFixMe, getState: $TSFixMe, { container }: { container: () => CommanderContainer }) => {
        const {
            appLocalizationComponent: { parseDate },
        } = container();
        const safeConvertToUtcDateString = createSafeToUtcDateStringConverter(parseDate);
        const startUtc = safeConvertToUtcDateString(startDate);
        const endUtc = safeConvertToUtcDateString(endDate);

        dispatch(changeDateFilter({ startUtc, endUtc }, rateId));

        return dispatch(
            fetchRateManagementData({ productId, rateId, serviceId, startUtc, endUtc }, { occupancy: true })
        );
    };
